import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { PartTreeNode } from '../../../types/drbfm';

interface PartTreeTableProps {
  parts: PartTreeNode[];
}

const PartTreeTable: React.FC<PartTreeTableProps> = ({ parts }) => {
  const { t } = useTranslation();

  return (
  <div className="max-h-80 overflow-auto">
    <Table aria-label={t('drbfm.workflow.matrix.partTreeAriaLabel', '部品ツリー')}>
      <TableHeader className="sticky top-0 z-10 bg-card">
        <TableRow>
          <TableHead>{t('drbfm.workflow.matrix.partNoHeader', '部品No.')}</TableHead>
          <TableHead>{t('drbfm.workflow.matrix.unitHeader', 'ユニット')}</TableHead>
          <TableHead>{t('drbfm.workflow.matrix.partNameHeader', '部品名')}</TableHead>
          <TableHead>{t('drbfm.workflow.matrix.roleHeader', '役割')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {parts.map((part) => (
          <TableRow key={part.id}>
            <TableCell>{part.partNo}</TableCell>
            <TableCell>{part.unitName || '—'}</TableCell>
            <TableCell>{part.partName}</TableCell>
            <TableCell>{part.role || '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
  );
};

export default PartTreeTable;
